import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconUnarchiv: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconUnarchiv"><Path fillRule="evenodd" clipRule="evenodd" d="M10.4056 3.15622L6.85078 6.00005H17.1492L13.5944 3.15622L14.8438 1.59448L21 6.51942V21H3V6.51942L9.15617 1.59448L10.4056 3.15622ZM9 10H15V12H9V10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconUnarchiv;
